export default __webpack_public_path__ + "static/media/380.2c030d53.jpg";